import { Link } from "react-router-dom";
import { cn } from "../../lib/cn";
import { fr } from "../../i18n/fr";

export function Logo({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <Link to="/" className={cn("group inline-flex min-w-0 items-center gap-3", className)} aria-label={fr.brand.name}>
      <EtheriaMark className="h-10 w-10 shrink-0 sm:h-11 sm:w-11" />
      {!compact && (
        <span className="flex min-w-0 flex-col leading-none max-[360px]:hidden">
          <span className="truncate font-display text-lg font-bold tracking-[0.12em] text-parchment-50 text-engraved sm:text-xl">
            ETHERIA
          </span>
          <span className="mt-1 truncate text-[9px] uppercase tracking-[0.16em] text-arcane-200/90 sm:text-[10px]">
            {fr.brand.tagline}
          </span>
        </span>
      )}
    </Link>
  );
}

export function EtheriaMark({ className }: { className?: string }) {
  return (
    <img
      src="/assets/brand/etheria-forge-crest.png"
      alt=""
      aria-hidden
      className={cn("object-cover", className)}
      draggable={false}
    />
  );
}
